export default function prepareDuplicatedInspection(item, model, sections) {
    if (!item) return item

    const duplicated = { ...item, id: undefined }
    if (duplicated.pictures) duplicated.pictures = []

    sections?.forEach((section) => {
        section.eav_columns
        ?.filter((eavColumn) => [7, 8].includes(eavColumn.column_type_id))
            .forEach((eavColumn) => {
                if (duplicated[eavColumn.description]) {
                    duplicated[eavColumn.description] = []
                }
            })
    })
    return duplicated
}